// @ts-nocheck
import { QuerySelect } from "components/Inputs/CustomAsyncSelect/CustomAsyncSelect";
import { t } from "i18next";
import genRequest from "includes/request";
import React from "react";
import siteLabel from "includes/siteLabel";

export default function SitesSelect(props) {

	const {companyId} = props
	return (
		<QuerySelect
			placeholder={t("Sites.SELECT_SITES")}
			className={"bg-color w-100 rounded"}
			classNamePrefix="dropdown"
			queryKey={["Sites", "SitesOfCompany", companyId]}
			queryFn={() => genRequest("sites/company/" + companyId)}
			treat={(site) => ({
				value: site.id,
				SiteId: site.id,
				label: siteLabel(site)
			})}
			isSearchable={true}
			{...props}
		/>
	)
}
